import * as React from 'react'
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";


export default function notificationColumn() {
	return {
		name: 'isNotification', label: 'Notification',
		options: {
			headerAlign: 'center',
			setCellProps: () => ({ sx: { minWidth: '120px' }}),
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				<IconSeeker
					icon={ value ? "check-to-slot" : "xmark-to-slot" }
					sx={{ color: value ? "success.main" : "error.main", fontSize: "1.5rem" }}
				/>
			</Box>
		}
	}
}